import React from 'react'
import './index.styl'

const disabled = process.env.CONVERSE_DISABLED == 'true'

export default function Chat (props) {
  const htmlRef = React.createRef()
  //const [initialized, setInitialized] = React.useState(false)
  /*
  React.useEffect(() => {
    if (!disabled && converse && props.settings && htmlRef.current && props.loaded && !initialized) {
      const view_mode = 'embedded' //props.width >= 950 ? 'embedded' : 'mobile'
      converse.initialize({
        ...props.settings,
        view_mode,
        i18n: props.languageId,
        refresh_profile_handler: async (user,_converse) => {
          _converse.roster.data.save('version', null);
          props.reloadSettings()
          await user.logout()
          setInitialized(false)
        }
      })
      setInitialized(true)
    }
  }, [htmlRef, props.loaded, initialized])
  */

  React.useEffect(() => {
    if (htmlRef.current) {
      window.chatContainer = htmlRef.current
      window.onChatContainer && window.onChatContainer(htmlRef.current, props.pageName)
    }
  }, [props.pageName, htmlRef])

  return (
    <div id="conversejs" ref={htmlRef} style={props.style} />
  )
}
